import React from 'react';
import { InformationCircleIcon } from '@heroicons/react/24/solid';

const MismatchInfo = ({ className }) => {
    return (
        <>
            <div className={`flex ${className} mt-3`}>
                <InformationCircleIcon className='h-5 w-5 text-primary mx-1 warning-info-icon' />
                <small className='text-primary pr-4'>The highlighted rows have mismatched data types.</small>
            </div>
        </>
    );
};

export default MismatchInfo;
